// extracted by mini-css-extract-plugin
var _1 = "RentalPortalBlockDisabledEditButton-moduletooltipWrapper__MRNlB";
export { _1 as "tooltipWrapper" }
